import { FunctionComponent } from 'react';

import ArrowDownIcon from '../Arrow/ArrowDown.icon';
import { IconPropsInterface } from '../Icon.types';

const ChevronDownIcon: FunctionComponent<IconPropsInterface> = ({
  color = 'black',
  size = '24px',
  ...rest
}) => <ArrowDownIcon size={size} color={color} {...rest} />;

ChevronDownIcon.displayName = 'ChevronDownIcon';

export default ChevronDownIcon;
